import V3Check from './V3Check'
import { CheckUtils } from 'utils'
import { MiniNotice, HelpLink } from 'components'

const ERROR_ICON = <img src="//decm9lxovq8aw.cloudfront.net/images/customerwebsite/error.png" />

export default class V3SubheadingsCheck extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)

    this.renderInfo = this.renderInfo.bind(this)
    this.renderDetails = this.renderDetails.bind(this)
  }

  render() {
    const props = {
      ...this.props,
      info: this.renderInfo,
      details: this.renderDetails
    }

    return <V3Check { ...props } />
  }

  renderDetails() {
    return CheckUtils.renderDetailsList(this.props.check.checkItems)
  }

  renderGoodStructureSnippet() {
    return `
    <body>
        <h1>Men's Red Parka Winter Jacket</h1>
        <p>Stay both stylish and warm in temperatures of -20 to -30 degrees.</p>

        <h2>Garment care instructions</h2>
        <p>Dry clean only. Recommended to clean at least once a season.</p>
        
        <h2>Returns information</h2>
        <p>We offer free 30-day returns within Canada.</p>
    </body>`
  }

  renderFreePageInstructions() {
    const pageType = localStorage.getItem('pageType').replace(':', '').replace('page_type.', '')

    switch(pageType) {
      case "homepage":
        return this.renderHomepageInstructions()
      case "catalog":
        return this.renderCatalogInstructions()
      case "collection":
        return this.renderCollectionInstructions()
      case "product":
        return this.renderProductInstructions()
      case "blogHome":
        return this.renderBlogHomeInstructions()
      case "blogPost":
        return this.renderBlogPostInstructions()
      case "page":
        return this.renderPageInstructions()
      default:
        return this.renderOtherInstructions()
    }
  }

  renderInfo() {
    return (
      <div>
        <div>
          <h2>Key points</h2>
          <p>
            The H2, H3, H4 etc. are subheadings. Together these clearly define page topics.
          </p>
          <hr />
          <h2>How it's used</h2>
          <ul>
            <li>Used in search engine algorithms</li>
            <li>Specifically using these heading tags rather than just normal paragraph text makes it easier for search engines to determine topics</li>
          </ul>
          <hr />
          <h2>Best practice</h2>
          <ul>
            <li>Add multiple H2, H3 etc if the page splits into other sub-topics</li>
            <li>Headings should be in text, not images</li>
            <li>Including keywords here guides search engines on the details that this page contains</li>
            <li>
              For example: 
              <pre className="details__content__code-example">{ this.renderGoodStructureSnippet() }</pre>
            </li>
          </ul>
          <hr />
        </div>

        <div>
          <h2>Fix this yourself</h2>
          {this.renderFreePageInstructions()}
        </div>
      </div>
    )
  }

  renderEditSubheadings() {
    const currentUser = this.context.currentUser
    const themesLink = 'https://' + currentUser.shop + '/admin/themes'

    return (
      <div>
        <p>Every theme is structured differently so you will first have to locate which pieces of text in your theme is being defined as your subheadings.</p>

        <ol>
          <li>View your website</li>
          <li>Right click and select ‘View Page Source’</li>
          <li>Type Control+F (Command+F on a Mac) to open the search box</li>
          <li>Search for <code>&lt;/h2&gt; or &lt;/h3&gt;</code> or <code>&lt;/h4&gt;</code> in the file to find the subheadings</li>
          <li>The text between the <code>&lt;h2&gt;&lt;/h2&gt;, &lt;h3&gt;&lt;/h3&gt;,</code> and <code>&lt;h4&gt;&lt;</code>/h4> tags are your subheadings</li>
        </ol>

        <p>Once you have identified your subheadings you will need to locate where to edit them. Most subheading text can be changed inside your theme ‘Customize’ settings.</p>

        <ol>
          <li><a href={themesLink}>View your themes</a> in Shopify</li>
          <li>Select ‘Customize’ for your live theme</li>
          <li>Find the origin of that text inside your ‘Customize’ settings</li>
          <li>Update the text to include provide a summary of your products and brand. Include 1-3 of your keywords.</li>
        </ol>
      </div>
    )
  }

  renderDoubleNotice() {
    return (
      <div>
        <MiniNotice
          alert
          header="Coding required"
          note={
            <span>New to coding? <a href="https://support.pluginuseful.com/hc/en-us/articles/23534791516308-A-Guide-to-HTML-Code-Basics" target="_blank">Read our guide of HTML code basics</a></span>
          }
        />
        <MiniNotice
          error
          header="Site styles may be affected"
          note="We strongly recommend testing changes in a theme copy."
        />
      </div>
    )
  }

  renderSchema() {
    return `
      <div>
        <div>
          {% if section.settings.heading != blank %}
            <h1 style="text-align:center;margin-left:24px;margin-right:24px;">{{ section.settings.heading }}</h1>
          {% endif %}
          {% if section.settings.subheading != blank %}
            <h2 style="text-align:center;margin-left:24px;margin-right:24px;">{{ section.settings.subheading }}</h2>
          {% endif %}
        </div>
      </div>

      {% schema %}
      {
      "name": {
        "en": "SEO Headings"
      },
      "class": "index-section",
      "settings": [
        {
          "type": "text",
          "id": "heading",
          "label": {
            "en": "Heading"
          },
          "default": {
            "en": "Add your primary heading here"
          }
        },
        {
          "type": "text",
          "id": "subheading",
          "label": {
            "en": "Subheading"
          },
          "default": {
            "en": "Add your subheading here"
          }
        }
      ],
      "presets": [
        {
          "name": {
            "en": "SEO Headings"
          },
          "category": {
            "en": "SEO"
          }
        }
      ]
      }
      {% endschema %}
    `
  }

  renderAddSectionCode() {
    return `{% section 'seo-headings' %}`
  }

  renderAddSubheadings() {
    const currentUser = this.context.currentUser
    const themesLink = 'https://' + currentUser.shop + '/admin/themes'

    return (
      <div>
        <ol>
          <li><a href={themesLink} target="_blank">View your themes</a> in Shopify</li>
          <li>Select ‘Actions’ and  ‘Edit code’ for the relevant theme</li>
          <li>Go the the Sections folder</li>
          <li>Click ‘Add a new section'</li>
          <li>Call it seo-headings</li>
          <li>Create section</li>
          <li>Delete the file content</li>
          <li>
            Add the following piece of code to the new section file and save
            <pre className="details__content__code-example details__content__code-example--condensed">{this.renderSchema()}</pre>
          </li>
          <li>Go to ‘Customize theme’</li>
          <li>Add the new section called 'SEO Headings'</li>
          <li>Move the section to the desired location on the page</li>
          <li>Input your subheading text to include provide a summary of your products and brand. Include 2-3 of your top keywords.</li>
        </ol>
      </div>
    )
  }

  renderHomepageInstructions() {
    return (
      <div>
        <h3>Edit your homepage subheadings</h3>
        {this.renderEditSubheadings()}

        <h3>Add a homepage subheadings</h3>
        {this.renderDoubleNotice()}

        <p>By creating a new section on your homepage you can add a new piece of text as your subheading.</p>
        {this.renderAddSubheadings()}

        <h3>Troubleshooting</h3>
        <ul className="icon-font-list details__content__troubleshooting-list">
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534805888148-What-are-good-headings-h1-and-subheadings-h2-h3-h4"
            title="What are good H1 and H2 Headings?"
          />
        </ul>
      </div>
    )
  }

  renderCatalogInstructions() {
    const currentUser = this.context.currentUser
    const themesLink = 'https://' + currentUser.shop + '/admin/themes'

    return (
      <div>
        <h3>Edit your catalog subheadings</h3>
        {this.renderEditSubheadings()}

        <h3>Add a catalog subheading</h3>
        { this.renderDoubleNotice() }
        <p>First, you will need to create a new section in your theme.</p>
        <ol>
          <li><a href={themesLink} target="_blank">View your themes</a> in Shopify</li>
          <li>Select ‘Actions’ and  ‘Edit code’ for the relevant theme</li>
          <li>Go the 'Sections' folder</li>
          <li>Click ‘Add a new section;</li>
          <li>Call it seo-headings</li>
          <li>Create section</li>
          <li>Delete the file content</li>
          <li>
            Add the following piece of code to the new section file and save
            <pre className="details__content__code-example details__content__code-example--condensed">{ this.renderSchema() }</pre>
          </li>
        </ol>

        <p>Next, you will need to add this section to your catalog page. For most themes, this will need to be done by manually editing the code.</p>
        <ol>  
          <li>Go to the 'Templates' folder</li>
          <li>Find the template file for your catalog page. It is likely called something like list-collections.liquid.</li>
          <li>
            Add the following code to the file and save
            <pre className="details__content__code-example small-spacing--top">{ this.renderAddSectionCode() }</pre>
          </li>
          <li>Adjust placement on the page. You will likely see other sections listed in this file, place the seo-headings section above or below these sections as desired.</li>
        </ol>

        <p>Finally, you can edit add your subheading to this new section.</p>
        <ol>
          <li>Go to ‘Customize theme’</li>
          <li>Select the 'Collections List' page</li>
          <li>View the new section called 'SEO Headings'</li>
          <li>Input your subheading text to provide a summary of your products and brand. Include 2-3 of your top keywords.</li>
        </ol>

        <h3>Troubleshooting</h3>
        <ul className="icon-font-list details__content__troubleshooting-list">
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534805888148-What-are-good-headings-h1-and-subheadings-h2-h3-h4"
            title="What are good H1 and H2 Headings?"
          />
        </ul>
      </div>
    )
  }

  renderCollectionInstructions() {
    const currentUser = this.context.currentUser
    const collectionsLink = 'https://' + currentUser.shop + '/admin/collections'

    return (
      <div>
        <h3>Edit your collection subheadings</h3>
        <p>You can edit your subheadings <code>&lt;h2&gt;&lt;/h2&gt;, &lt;h3&gt;&lt;/h3&gt;, &lt;h4&gt;&lt;/h4&gt;</code> in your collection description.</p>

        <ol>
          <li><a href={collectionsLink} target="_blank">Go to your collections</a> in your Shopify admin</li>
          <li>View the relevant collection page</li>
          <li>Edit the text in the ‘Description’ field that is formatted as ‘Heading 2’, ‘Heading 3’, or ‘Heading 4’</li>
        </ol>

        <h3>Add a collection subheading</h3>
        <p>You can add one or more subheadings <code>&lt;h2&gt;&lt;/h2&gt;, &lt;h3&gt;&lt;/h3&gt;</code>, and <code>&lt;h4&gt;&lt;/h4&gt;</code> in your collection description.</p>

        <ol>
          <li><a href={collectionsLink} target="_blank">Go to your collections</a> in your Shopify admin</li>
          <li>View the relevant collection page</li>
          <li>Add the text you’d like to be your subheading in the ‘Description’ field</li>
          <li>Highlight the text and selecting the ‘Formatting’ option</li>
          <li>Choose either ‘Heading 2’, ‘Heading 3’, or ‘Heading 4’</li>
        </ol>

        <h3>Troubleshooting</h3>
        <ul className="icon-font-list details__content__troubleshooting-list">
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534805888148-What-are-good-headings-h1-and-subheadings-h2-h3-h4"
            title="What are good H1 and H2 Headings?"
          />
        </ul>
      </div>
    )
  }

  renderProductInstructions() {
    const currentUser = this.context.currentUser
    const productsLink = 'https://' + currentUser.shop + '/admin/products'

    return (
      <div>
        <h3>Edit your product subheadings</h3>
        <p>You can edit your subheadings <code>&lt;h2>&lt;/h2&gt;, &lt;h3&gt;&lt;/h3&gt;, &lt;h4>&lt;/h4&gt;</code> in your product description.</p>

        <ol>
          <li><a href={productsLink} target="_blank">Go to your products</a> in your Shopify admin</li>
          <li>View the relevant product page</li>
          <li>Edit the text in the ‘Description’ field that is formatted as ‘Heading 2’, ‘Heading 3’, or ‘Heading 4’</li>
        </ol>

        <h3>Add a product subheading</h3>
        <p>You can add one or more subheadings <code>&lt;h2&gt;&lt;/h2&gt;, &lt;h3&gt;&lt;/h3&gt;</code>, and <code>&lt;h4&gt;&lt;/h4&gt;</code> in your product description.</p>
        <ol>
          <li><a href={productsLink} target="_blank">Go to your products</a> in your Shopify admin</li>
          <li>View the relevant product page</li>
          <li>Add the text you’d like to be your subheading in the ‘Description’ field</li>
          <li>Highlight the text and selecting the ‘Formatting’ option</li>
          <li>Choose either ‘Heading 2’, ‘Heading 3’, or ‘Heading 4’</li>
        </ol>

        <h3>Troubleshooting</h3>
        <ul className="icon-font-list details__content__troubleshooting-list">
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534805888148-What-are-good-headings-h1-and-subheadings-h2-h3-h4"
            title="What are good H1 and H2 Headings?"
          />
        </ul>
      </div>
    )
  }

  renderBlogHomeInstructions() {
    const currentUser = this.context.currentUser
    const blogsLink = 'https://' + currentUser.shop + '/admin/blogs'
    const themesLink = 'https://' + currentUser.shop + '/admin/themes'

    return (
      <div>
        <h3>Edit your blog subheadings</h3>
        <p>Every theme is structured differently so you will first have to locate which pieces of text in your theme is being defined as your subheadings.</p>

        <ol>
          <li><a href={blogsLink} target="_blank">View your website blog</a></li>
          <li>Right click and select ‘View Page Source’</li>
          <li>Type Control+F (Command+F on a Mac) to open the search box</li>
          <li>Search for <code>&lt;/h2&gt;</code> or <code>&lt;/h3&gt;</code> or <code>&lt;/h4&gt;</code> in the file to find the subheadings</li>
          <li>The text between the <code>&lt;h2&gt;&lt;/h2&gt;, &lt;h3&gt;&lt;/h3&gt;</code>, and <code>&lt;h4&gt;&lt;/h4&gt;</code> tags is your subheadings</li>
        </ol>

        <p>Once you have identified the text that you will need to locate where to edit it. Most subheading text can be changed inside your theme ‘Customize’ settings.</p>

        <ol>
          <li><a href={themesLink} target="_blank">View your themes</a> in Shopify</li>
          <li>Select ‘Customize’ for your live theme</li>
          <li>Find the origin of that text inside your ‘Customize’ settings</li>
          <li>Update the text to include provide a summary of your products and brand. Include 2-3 of your top keywords.</li>
        </ol>

        <h3>Add blog subheadings</h3>
        { this.renderDoubleNotice() }
        <p>First, you will need to create a new section in your theme.</p>
        <ol>
          <li><a href={themesLink} target="_blank">View your themes</a> in Shopify</li>
          <li>Select ‘Actions’ and  ‘Edit code’ for the relevant theme</li>
          <li>Go the 'Sections' folder</li>
          <li>Click ‘Add a new section;</li>
          <li>Call it seo-headings</li>
          <li>Create section</li>
          <li>Delete the file content</li>
          <li>
            Add the following piece of code to the new section file and save
            <pre className="details__content__code-example details__content__code-example--condensed">{ this.renderSchema() }</pre>
          </li>
        </ol>

        <p>Next, you will need to add this section to your blog page. For most themes, this will need to be done by manually editing the code.</p>
        <ol>  
          <li>Go to the 'Templates' folder</li>
          <li>Find the template file for your blog page. It is likely called something like blog.liquid.</li>
          <li>
            Add the following code to the file and save
            <pre className="details__content__code-example small-spacing--top">{ this.renderAddSectionCode() }</pre>
          </li>
          <li>Adjust placement on the page. You will likely see other sections listed in this file, place the seo-headings section above or below these sections as desired.</li>
        </ol>

        <p>Finally, you can edit add your subheading to this new section.</p>
        <ol>
          <li>Go to ‘Customize theme’</li>
          <li>Select the 'Blogs' page</li>
          <li>View the new section called 'SEO Headings'</li>
          <li>Input your subheading text to provide a summary of your products and brand. Include 2-3 of your top keywords.</li>
        </ol>

        <h3>Troubleshooting</h3>
        <ul className="icon-font-list details__content__troubleshooting-list">
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534805888148-What-are-good-headings-h1-and-subheadings-h2-h3-h4"
            title="What are good H1 and H2 Headings?"
          />
        </ul>
      </div>
    )
  }

  renderBlogPostInstructions() {
    const currentUser = this.context.currentUser
    const articlesLink = 'https://' + currentUser.shop + '/admin/articles'

    return (
      <div>
        <h3>Edit your blog post subheadings</h3>
        <p>You can edit your subheadings <code>&lt;h2&gt;&lt;/h2&gt;, &lt;h3&gt;&lt;/h3&gt;, &lt;h4&gt;&lt;/h4&gt;</code> in your blog post content.</p>

        <ol>
          <li><a href={articlesLink} target="_blank">Go to your blog post</a> in your Shopify admin</li>
          <li>View the relevant blog post</li>
          <li>Edit the text in the ‘Content’ field that is formatted as ‘Heading 2’, ‘Heading 3’, or ‘Heading 4’</li>
        </ol>

        <h3>Add a blog post subheading</h3>
        <p>You can add one or more subheadings <code>&lt;h2&gt;&lt;/h2&gt;, &lt;h3&gt;&lt;/h3&gt;</code>, and <code>&lt;h4&gt;&lt;/h4&gt;</code> in your blog post content.</p>

        <ol>
          <li><a href={articlesLink} target="_blank">Go to your blog posts</a> in your Shopify admin</li>
          <li>View the relevant blog post</li>
          <li>Add the text you’d like to be your subheading in the ‘Content’ field</li>
          <li>Highlight the text and selecting the ‘Formatting’ option</li>
          <li>Choose either ‘Heading 2’, ‘Heading 3’, or ‘Heading 4’</li>
        </ol>

        <h3>Troubleshooting</h3>
        <ul className="icon-font-list details__content__troubleshooting-list">
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534805888148-What-are-good-headings-h1-and-subheadings-h2-h3-h4"
            title="What are good H1 and H2 Headings?"
          />
        </ul>
      </div>
    )
  }

  renderPageInstructions() {
    const currentUser = this.context.currentUser
    const pagesLink = 'https://' + currentUser.shop + '/admin/pages'

    return (
      <div>
        <h3>Edit your page subheadings</h3>
        <p>You can edit your subheadings <code>&lt;h2&gt;&lt;/h2&gt;, &lt;h3&gt;&lt;/h3&gt;, &lt;h4&gt;&lt;/h4&gt;</code> in your page content.</p>

        <ol>
          <li><a href={pagesLink} target="_blank">Go to your online store > pages</a> in your Shopify admin</li>
          <li>View the relevant page</li>
          <li>Edit the text in the Content field that is formatted as ‘Heading 2’, ‘Heading 3’, or ‘Heading 4’</li>
        </ol>

        <h3>Add a page subheading</h3>
        <p>You can add one or more subheadings <code>&lt;h2&gt;&lt;/h2&gt;, &lt;h3&gt;&lt;/h3&gt;</code>, and <code>&lt;h4&gt;&lt;/h4&gt;</code> in your page content.</p>

        <ol>
          <li><a href={pagesLink} target="_blank">Go to your online store > pages</a> in your Shopify admin</li>
          <li>View the relevant page</li>
          <li>Add the text you’d like to be your subheading in the Content field</li>
          <li>Highlight the text and selecting the ‘Formatting’ option</li>
          <li>Choose either ‘Heading 2’, ‘Heading 3’, or ‘Heading 4’</li>
        </ol>

        <h3>Troubleshooting</h3>
        <ul className="icon-font-list details__content__troubleshooting-list">
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534805888148-What-are-good-headings-h1-and-subheadings-h2-h3-h4"
            title="What are good H1 and H2 Headings?"
          />
        </ul>
      </div>
    )
  }

  renderOtherInstructions() {
    const currentUser = this.context.currentUser
    const themesLink = 'https://' + currentUser.shop + '/admin/themes'

      return (
        <div>
          <h3>Edit your subheadings</h3>
          <p>Every theme is structured differently so you will first have to locate which pieces of text in your theme is being defined as your subheadings.</p>

          <ol>
            <li>View your website and go to the relevant page</li>
            <li>Right click and select ‘View Page Source’</li>
            <li>Type Control+F (Command+F on a Mac) to open the search box</li>
            <li>Search for <code>&lt;/h2&gt;</code> or <code>&lt;/h3&gt;</code> or <code>&lt;/h4&gt;</code> in the file to find the subheadings</li>
            <li>The text between the <code>&lt;h2&gt;&lt;/h2&gt;</code>, <code>&lt;h3&gt;&lt;/h3&gt</code>;, and <code>&lt;h4&gt;&lt;/h4&gt</code>; tags is your subheadings</li>
          </ol>

          <p>Once you have identified the text that you will need to locate where to edit it. Most subheading text can be changed inside your theme ‘Customize’ settings.</p>

          <ol>
            <li><a href={themesLink} target="_blank">View your themes</a> in Shopify</li>
            <li>Select ‘Customize’ for your live theme</li>
            <li>Find the origin of that text inside your ‘Customize’ settings</li>
            <li>Update the text to include provide a summary of your products and brand. Include 1-3 of your keywords.</li>
          </ol>

          <h3>Add a subheadings</h3>
          <p>By creating a new section on your the relevant page you can add a new piece of text as your subheading.</p>
          {this.renderAddSubheadings()}

          <h3>Troubleshooting</h3>
          <ul className="icon-font-list details__content__troubleshooting-list">
            <HelpLink
              url="https://support.pluginuseful.com/hc/en-us/articles/23534805888148-What-are-good-headings-h1-and-subheadings-h2-h3-h4"
              title="What are good H1 and H2 Headings?"
            />
          </ul>
        </div>
      )
  }
}



// WEBPACK FOOTER //
// ./app/components/v3_checks/V3SubheadingsCheck.js